import { createSelector } from 'reselect';
import Select, { StylesConfig } from 'react-select';
import { useRedux } from '../hooks';
import {
    changeInstance,
    changeSelectedChat,
    resetDirectMessages
} from '../redux/actions';

const InstanceSelector = () => {
    const { dispatch, useAppSelector } = useRedux();
    const errorData = createSelector(
        (state: any) => state.Login,
        (props: any) => props.Chats,
        (state, props) => ({
            selectedInstance: props.selectedInstance,
            instances: state.user.instances
        })
    );

    const { instances, selectedInstance } = useAppSelector(errorData);

    const options = instances.map((i: string) => ({
        value: i,
        label: i
    }));

    const customSelectStyles: StylesConfig = {
        menu: (styles) => ({
            ...styles,
            zIndex: 3
        }),
        option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            backgroundColor: isSelected
                ? '#4eac6d50'
                : isFocused
                  ? '#4eac6d50'
                  : 'white',
            color: 'black'
        })
    };

    const onChangeInstance = (e: any) => {
        dispatch(changeInstance(e));
        dispatch(changeSelectedChat(null));
        dispatch(resetDirectMessages());
    };
    return (
        <div className="container-fluid border-4 border-bottom border-primary select-number-box ">
            <div className="container px-2 py-2 d-flex justify-content-center justify-content-lg-between align-items-center gap-3 ">
                <h5 className="m-0 text-secondary fs-6">Account:</h5>
                <Select
                    placeholder="Select DID Number"
                    options={options}
                    defaultValue={selectedInstance}
                    onChange={onChangeInstance}
                    isSearchable
                    className="select-number"
                    styles={customSelectStyles}
                    theme={(theme) => ({
                        ...theme,
                        borderRadius: 0,
                        colors: {
                            ...theme.colors,
                            primary: '#4eac6d',
                            primary75: '#4eac6d75',
                            primary50: '#4eac6d50',
                            primary25: '#4eac6d25'
                        }
                    })}
                />
            </div>
        </div>
    );
};

export default InstanceSelector;
